/**
 *
 * @module playlistType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef PlaylistType
 * @type {Object}
 * @since 2.0.0
 * @desc Enumerates the available playlist types for media.
 * @example PlaylistType.COMPLETE // 'COMPLETE'
 *
 * @property {String} COMPLETE - The "complete" playlist type.
 * @property {String} SLIDE - The "slide" playlist type.
 *
 */

/**
 *
 * @enum
 * @type {PlaylistType}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    COMPLETE: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    SLIDE: null
});



// WEBPACK FOOTER //
// ./src/media/playlistType.js